// extracted by mini-css-extract-plugin
module.exports = {"content":"Dropdown_content__UKrs2","fade_in_dropdown":"Dropdown_fade_in_dropdown__TjlFB","open":"Dropdown_open__o4OEO"};